import { render } from "./update_address.vue?vue&type=template&id=3366bf60&scoped=true"
import script from "./update_address.vue?vue&type=script&lang=js"
export * from "./update_address.vue?vue&type=script&lang=js"

import "./update_address.vue?vue&type=style&index=0&id=3366bf60&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3366bf60"]])

export default __exports__